// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type PlayArrow20FilledProps = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const PlayArrow20Filled: FC<PlayArrow20FilledProps> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="20"
            height="20"
        >
            <path d="M7 15.5v-11l8.5 5.5L7 15.5Z" />
        </svg>
    );
};

export default PlayArrow20Filled;
